<template>
	<section class="app-container payment">

		<h3 class="text-center">
			Welcome, <strong>{{ user ? user.username : '' }}</strong>!
		</h3>

		<h3 class="text-center mb-5">
			Fill in the form below, to get your <span class="emphasise">$ {{ freeTierCash }} free</span> credits!
		</h3>
		
		<div class="row justify-content-center pt-3">
			<div class="col-md-6 col-lg-5 col-xl-4">
				<CardForm ref="cardForm" />
			</div>
			<div class="col-md-6 col-lg-5 col-xl-4">
				<AddressForm ref="addressForm" />
			</div>
		</div>
		<div class="row justify-content-center mt-5">
			<button
				class="btn btn-primary col-2"
				type="button"
				@click="submitCard"
			>
				<span
					v-if="loading"
					class="spinner-border spinner-border-sm"
					role="status"
					aria-hidden="true"
				></span>
				Save
			</button>
		</div>
		<ErrorDialog ref="errDialog" />
	</section>
</template>

<script>
import AddressForm from './AddressForm';
import CardForm from './CardForm';
import CardService from '../../services/card';
import ConsoleService from '../../services/console';
import ErrorDialog from '../shared/ErrorDialog';
import BonusService from '../../services/bonus';

export default {
	name: 'CardNew',
	props: ['user'],
	components: {
		AddressForm,
		CardForm,
		ErrorDialog,
	},
	data() {
		return {
			loading: false,
			bonuses: [],
		};
	},
	mounted() {
		this.searchBonus();
	},
	methods: {
		submitCard() {
			this.loading = true;
			this.$refs.cardForm.getCard().then((result) => {
				if (!result) {
					this.loading = false;
					return;
				}
				let token = result.token;
				let name = result.name;
				let address = this.$refs.addressForm.getAddress();
				let paymentInfo = {
					card: {
						token: token.id,
						cardHolderName: name,
					},
					address,
				};
				CardService.instance()
					.createCardAndAddress(paymentInfo)
					.then(() =>  ConsoleService.instance().refreshToken())
					.then(() => {
						this.loading = false;
						this.$router.push({ path: '/console/' });
						window.location.reload();
					})
					.catch((err) => {
						this.loading = false;
						this.$refs.errDialog.show(err);
					});
			});
		},
		searchBonus(search = { page: 0, size: 50 }) {
			BonusService.instance()
				.searchBonus(search)
				.then((data) => {
					this.loading = false;
					this.bonuses = data.data.content;
				});
		},
	},
	computed: {
		freeTierCash() {
			if (this.bonuses && this.bonuses.length > 0) {
				let discount = this.bonuses.find(
					(b) => b.key === 'CONSOLE_DISCOUNT',
				);
				
				return discount ? (discount.cents / 100).toFixed(2) : 0;
			} else {
				return 0;
			}
		},
	},
};
</script>

<style>
.emphasise {
	font-weight: bold;
	font-size: 1.8rem;
}
</style>
